import { RequestOtpV3Dto, RequestOtpV3Resp } from "@usecase/otp/request-otp-v3/request-otp-v3.type";
import { RequestOtpDto, RequestOtpResp } from "@usecase/otp/request-otp/request-otp.type";
import { Observable } from "rxjs";

export abstract class OtpRepository {
    abstract requestOtp(payload: RequestOtpDto): Observable<RequestOtpResp>;
    abstract requestOtpV3(payload: RequestOtpV3Dto): Observable<RequestOtpV3Resp>;
}